import { makeAutoObservable } from "mobx";

export class ProfileDashBoardStore {
    isExpandedAllLists = false;
    activeLeagueTab: "plan" | "sales" = "plan";

    constructor() {
        makeAutoObservable(this);
    }

    toggleExpandedAllLists() {
        this.isExpandedAllLists = !this.isExpandedAllLists;
    }

    setExpandedAllLists(value: boolean) {
        this.isExpandedAllLists = value;
    }

    setActiveLeagueTab(tab: "plan" | "sales") {
        this.activeLeagueTab = tab;
    }
}

export const profileDashboardStore = new ProfileDashBoardStore();
